<template>
  <section id="contact" class="ec-section contact">
    <div class="ec-container">
      <div class="contact__card" v-reveal>
        <div class="contact__bg" aria-hidden="true">
          <span class="blob blob--1"></span>
          <span class="blob blob--2"></span>
        </div>
        <div class="contact__grid">
          <div class="contact__copy">
            <span class="ec-eyebrow">{{ $t('contact.eyebrow') }}</span>
            <h2 class="contact__title">{{ $t('contact.titlePre') }}<span class="ec-gradient-text">{{ $t('contact.titleHi') }}</span>{{ $t('contact.titleSuf') }}</h2>
            <p class="contact__lead">{{ $t('contact.lead') }}</p>
            <ul class="contact__info">
              <li><span>✉️</span> {{ $t('contact.info.email') }}</li>
              <li><span>📍</span> {{ $t('contact.info.address') }}</li>
            </ul>
          </div>

          <form class="contact__form" @submit.prevent="submit">
            <div class="field">
              <label>{{ $t('contact.form.name') }}</label>
              <input v-model="form.name" type="text" :placeholder="$t('contact.form.namePlaceholder')" required />
            </div>
            <div class="field">
              <label>{{ $t('contact.form.contact') }}</label>
              <input v-model="form.phone" type="text" :placeholder="$t('contact.form.contactPlaceholder')" required />
            </div>
            <div class="field">
              <label>{{ $t('contact.form.company') }}</label>
              <input v-model="form.company" type="text" :placeholder="$t('contact.form.companyPlaceholder')" />
            </div>
            <div class="field">
              <label>{{ $t('contact.form.message') }}</label>
              <textarea v-model="form.msg" rows="3" :placeholder="$t('contact.form.messagePlaceholder')"></textarea>
            </div>
            <button type="submit" class="ec-btn ec-btn-primary contact__submit">
              {{ submitted ? $t('contact.submitted') : $t('contact.submit') }}
            </button>
            <p class="contact__hint">{{ $t('contact.hint') }}</p>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      submitted: false,
      form: { name: '', phone: '', company: '', msg: '' }
    }
  },
  methods: {
    submit() {
      // Demo only — no backend wired up.
      this.submitted = true
      setTimeout(() => {
        this.submitted = false
        this.form = { name: '', phone: '', company: '', msg: '' }
      }, 2800)
    }
  }
}
</script>

<style scoped>
.contact__card { position: relative; border-radius: 30px; overflow: hidden; border: 1px solid var(--ec-line); background: linear-gradient(160deg, rgba(20,28,56,.7), rgba(10,15,33,.85)); box-shadow: var(--ec-shadow); }
.contact__bg { position: absolute; inset: 0; }
.blob { position: absolute; border-radius: 50%; filter: blur(80px); opacity: .5; }
.blob--1 { width: 420px; height: 420px; background: radial-gradient(circle,#FF9900,transparent 70%); top: -160px; right: -80px; }
.blob--2 { width: 360px; height: 360px; background: radial-gradient(circle,#FF6F00,transparent 70%); bottom: -150px; left: -60px; }

.contact__grid { position: relative; display: grid; grid-template-columns: 1fr 1fr; gap: 50px; padding: 56px; }

.contact__title { font-size: clamp(28px, 3.4vw, 40px); margin: 18px 0 16px; }
.contact__lead { color: var(--ec-text-soft); font-size: 16px; margin-bottom: 28px; }
.contact__info { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 14px; }
.contact__info li { display: flex; align-items: center; gap: 12px; font-size: 15px; color: var(--ec-text); }
.contact__info span { font-size: 18px; }

.contact__form { background: rgba(255,255,255,.04); border: 1px solid var(--ec-line); border-radius: 20px; padding: 28px; }
.field { margin-bottom: 16px; }
.field label { display: block; font-size: 13px; color: var(--ec-text-soft); margin-bottom: 7px; font-weight: 500; }
.field input, .field textarea {
  width: 100%; padding: 12px 14px; border-radius: 11px;
  background: rgba(8,12,26,.6); border: 1px solid var(--ec-line); color: var(--ec-text);
  font-family: inherit; font-size: 15px; resize: vertical; transition: border-color .2s ease, box-shadow .2s ease;
}
.field input::placeholder, .field textarea::placeholder { color: var(--ec-text-mute); }
.field input:focus, .field textarea:focus { outline: none; border-color: var(--ec-blue); box-shadow: 0 0 0 3px rgba(255,153,0,.18); }
.contact__submit { width: 100%; margin-top: 6px; }
.contact__hint { font-size: 12px; color: var(--ec-text-mute); text-align: center; margin-top: 12px; }

@media (max-width: 820px) { .contact__grid { grid-template-columns: 1fr; gap: 36px; padding: 36px 26px; } }
</style>
